import { Link } from "react-router-dom";
import { ArrowLeft, Zap } from "lucide-react";
import { Footer } from "@/components/Footer";

export function LegalLayout({ title, eyebrow, updated, children, testid }) {
  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid={testid}>
      <header className="border-b border-border bg-card/85 backdrop-blur sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 group" data-testid="legal-logo">
            <span className="grid place-items-center h-9 w-9 rounded-xl bg-primary text-primary-foreground group-hover:rotate-6 transition-transform">
              <Zap className="h-5 w-5 fill-current" />
            </span>
            <span className="font-heading font-extrabold text-lg tracking-tight">AI Pathshaalaa</span>
          </Link>
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors" data-testid="legal-home">
            <ArrowLeft className="h-4 w-4" /> Home
          </Link>
        </div>
      </header>

      <main className="flex-1 w-full max-w-3xl mx-auto px-4 sm:px-6 py-12 md:py-16">
        {eyebrow && (
          <p className="font-mono text-xs font-bold uppercase tracking-widest text-primary mb-3">{eyebrow}</p>
        )}
        <h1 className="font-heading font-extrabold tracking-tight text-3xl md:text-4xl">{title}</h1>
        {updated && <p className="mt-3 text-sm text-muted-foreground">Last updated: {updated}</p>}
        <div className="mt-10">{children}</div>
      </main>

      <Footer />
    </div>
  );
}

export const H2 = ({ children }) => (
  <h2 className="font-heading font-extrabold tracking-tight text-xl md:text-2xl mt-10 mb-3 first:mt-0">{children}</h2>
);
export const P = ({ children }) => (
  <p className="text-[15px] leading-relaxed text-muted-foreground mb-4">{children}</p>
);
export const A = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="text-primary font-semibold underline underline-offset-2 hover:opacity-80">{children}</a>
);
export const UL = ({ children }) => (
  <ul className="list-disc pl-5 space-y-2 text-[15px] leading-relaxed text-muted-foreground mb-4">{children}</ul>
);
export const Strong = ({ children }) => <span className="font-semibold text-foreground">{children}</span>;
